import { Card } from '@/components/ui/card'
import { MandatoryRulesCard } from '@/features/app-patch-policy/mandatory-rules-card'
import { NativeVersionCard } from '@/features/app-patch-policy/native-version-card'

/** The "Change mandatory / optional flag" tab: Section A (Shorebird patch floor) and Section B
 * (native app-store version gate), each its own card. */
export function FlagPanel() {
  return (
    <div className="space-y-4">
      <Card>
        <MandatoryRulesCard />
      </Card>

      <Card>
        <NativeVersionCard />
      </Card>
    </div>
  )
}
